import router from "@/router";

class SortableTableManager {
  getColumns(data, tradPrefix = null, oldColumns = null, currentRouter = router) {
    let columns = [];
    if (data) {
      Object.keys(data).forEach((el, index) => {
        if (el !== "id") {
          // Exclude columns for planContract list.
          if (currentRouter.currentRoute.value.path.includes("plan-contract/list")) {
            if (el === "active" || el === "activeForRecruitment") {
              return;
            }
          }
          columns.push({
            name: el,
            tradPrefix: tradPrefix,
            sortable: true,
            sortWay: oldColumns && oldColumns[index] && oldColumns[index].sortWay ? oldColumns[index].sortWay : "",
            filterActive: true,
          });
        }
      });
    }
    return columns;
  }

  getEntriesColumns(columns, oldColumns = null) {
    let res = [];
    if (columns) {
      Object.entries(columns).forEach((column) => {
        if (column[1] !== "id" && column[1] !== "data") {
          res.push({
            name: column[1],
            sortable: true,
            sortWay:
              oldColumns && oldColumns[column[0]] && oldColumns[column[0]].sortWay ? oldColumns[column[0]].sortWay : "",
            isTranslatedName: true,
            index: column[0],
            filterActive: true,
          });
        }
      });
    }
    return res;
  }

  shouldExpandColumn = (type, index) => {
    return (type === "front-training" && index === 5) || (type === "front-training" && index === 6);
  };

  shouldReduceColumn = (type, index) => {
    return (
      (type === "front-training" && index === 0) ||
      (type === "front-training" && index === 3) ||
      (type === "front-training" && index === 7)
    );
  };
}

export const sortableTableManager = new SortableTableManager();
